/**
 * Category listing layout when `document.body` has `page` + `page--category-listing-page`
 * (CMS category listing page type).
 */

const sectionPanelTileCardContentStyles = {
  '& .chakra-link, & .chakra-link .chakra-text': {
    color: 'rgba(27, 26, 24, 0.90)',
    fontFamily: 'body',
    fontSize: {base: '16px', lg: '24px'},
    fontStyle: 'normal',
    fontVariantNumeric: 'lining-nums proportional-nums',
    fontWeight: 500,
    letterSpacing: {base: 0, lg: '-0.24px'},
    lineHeight: 1.2,
    padding: 'unset',
    textAlign: 'center',
    textDecoration: 'none',
    _hover: {
      textDecoration: 'none',
    },
  },
  '& .chakra-link .chakra-text': {
    display: '-webkit-box',
    noOfLines: 3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    whiteSpace: 'normal',
    width: '100%',
  },
  '& .contentful-card__description': {
    color: 'greyscale.70',
    fontFamily: 'body',
    fontSize: {base: '12px', lg: '14px'},
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 1.2,
    maxW: '100%',
    textAlign: 'center',
    width: '100%',
    display: '-webkit-box',
    noOfLines: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    whiteSpace: 'normal',
    '& p': {
      margin: 0,
      maxW: '100%',
      width: '100%',
      display: '-webkit-box',
      noOfLines: 2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      whiteSpace: 'normal',
    },
    '&.contentful-card__description--tile': {
      display: 'block',
      overflow: 'visible',
      textOverflow: 'unset',
      WebkitBoxOrient: 'unset',
      WebkitLineClamp: 'unset',
      whiteSpace: 'normal',
      '& p': {
        display: 'block',
        overflow: 'visible',
        textOverflow: 'unset',
        WebkitBoxOrient: 'unset',
        WebkitLineClamp: 'unset',
        whiteSpace: 'normal',
      },
    },
  },
};

export const categoryListPageGlobalStyles = {
  '.page--category-listing-page': {
    '& .component-container__background': {
      '& .component--container:has( .component--hero-banner)': {
        '& .component--hero-banner': {
          paddingY: {base: '60px', lg: '120px'},
          paddingX: {base: '60px', lg: '120px'},
          '& .component--action-links:hover p, & .component--action-links:hover, & .component--action-links:hover a': {
            textDecoration: 'none',
          },
        },
      },
    },
    '.component--container': {
      '&:has(.sf-product-list-lazy-grid)': {
        paddingX: {base: 'unset', md: 'unset'},
      },
      '&:has(.component--king-difference-media-cf013)': {
        display: 'inline-block',
      },
      '&:has(.component--product-tiles)': {
        paddingTop: {base: '64px', md: '100px'},
        paddingBottom: {base: '40px', md: '100px'},
      },
      '& .component--product-tiles': {
        paddingBottom: {base: '0', md: '0'},
        '&:first-of-type': {
          paddingTop: {base: '0', md: '0'},
        },
      },
      '& .component--product-tiles + .component--product-tiles': {
        paddingTop: {base: '40px', md: '84px'},
      },
    },
    '& #app-main:has(.category-landing-region)': {
      '& .category-landing-region': {
        display: 'flex',
        flexDirection: 'column',
        gap: {base: '16px', lg: '80px'},
      },
      '& .category-landing-region__module:has( > .component--hero-banner) + .category-landing-region__module': {
        marginTop: {base: '-16px', lg: '-80px'},
      },
      '& .hero-content-wrapper': {
        '& .component--action-links .link--outlined-dark': {
          paddingX: '48px',
          paddingY: '14px',
        }
      },
      '& .component--category-card-grid .contentful-category-card-grid__heading': {
        display: 'none',
      },
    },
  },
  '.page--range-detail': {
    '& .component-container__background': {
      '& .component--container:has( .component--hero-banner)': {
        '& .component--hero-banner': {
          paddingY: {base: '60px', lg: '120px'},
          paddingX: {base: '60px', lg: '120px'},
          '& .component--action-links:hover p, & .component--action-links:hover, & .component--action-links:hover a': {
            textDecoration: 'none',
          },
        },
      },
    },
    '.component--container': {
      '&:has(.sf-product-list-lazy-grid)': {
        paddingX: {base: 'unset', md: 'unset'},
      },
      '&:has(.component--king-difference-media-cf013)': {
        display: 'inline-block',
      },
      '&:has(.component--product-tiles)': {
        paddingTop: {base: '64px', md: '100px'},
        paddingBottom: {base: '40px', md: '100px'},
      },
      '& .component--product-tiles': {
        paddingBottom: {base: '0', md: '0'},
        '&:first-of-type': {
          paddingTop: {base: '0', md: '0'},
        },
      },
      '& .component--product-tiles + .component--product-tiles, & .component--product-tiles + .component--category-card-grid, & .component--category-card-grid + .component--product-tiles,  & .component--category-card-grid + .component--category-card-grid': {
        paddingTop: {base: '40px', md: '84px'},
      },
    },
  },
  'body.page--category-listing-page, body.page--range-detail': {
    '& .component-container__background': {
      '& .component--container:has( .component--split-heading)': {
        '& .component--split-heading:has(+ .component--teaser-tile-block)': {
          paddingTop: {base: '60px', md: '120px'},
          paddingBottom: {base: '40px', md: '64px'},
          '& .split-heading__left-region': {
            '& .split-heading__heading': {
              fontSize: {base: '28px', lg: '40px'},
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 1.2,
              letterSpacing: {base: '-0.28px', lg: '-0.4px'},
              fontVariantNumeric: 'lining-nums proportional-nums',
            },
          },
          '& .split-heading__right-region': {
            '& .split-heading__description': {
              fontSize: {base: '16px', lg: '18px'},
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 1.6,
            },
          },
        },
      },
    },
    '& #app-main': {
      '& .component--section-panel': {
        maxWidth: '1440px',
        paddingX: {base: '4px', lg: '80px'},
        marginX: 'auto',
      },
      '& .section-panel-split--5050:has(.contentful-card__content)': {
        alignItems: 'stretch',
        bg: 'brandColors.primaryBG',
        flexDirection: {base: 'column-reverse', lg: 'row'},
        flexShrink: 0,
        gap: 0,
        marginX: 0,
        maxWidth: '100%',
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: {base: '16px', lg: '80px'},
        width: '100%',
        '& .section-panel-split__column': {
          flex: {base: '0 0 auto', lg: '1 0 0'},
          flexShrink: 0,
          minWidth: 0,
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
        },
        '& .section-panel-split__column:has(.component--image)': {
          height: {base: '367px', lg: '640px'},
          minHeight: {base: '367px', lg: '640px'},
          '& > *': {
            height: '100%',
            width: '100%',
          },
          '& .component--image': {
            height: '100%',
            width: '100%',
          },
          '& img, & .chakra-image': {
            display: 'block',
            height: '100%',
            objectFit: 'cover',
            width: '100%',
          },
        },
        '& .section-panel-split__column:has(.contentful-card__content)': {
          bg: 'brandColors.secondaryBGTranslucent15',
          height: {base: '406px', lg: '640px'},
          minHeight: {base: '406px', lg: '640px'},
          '& .contentful-card__content': sectionPanelTileCardContentStyles,
        },
        '& .contentful-card__swatch-row': {
          '& .contentful-card__swatch-more': {
            '& .contentful-card__swatch-more-label--mobile': {
              display: {'base': 'none', 'lg': 'none'},
            },
            '& .contentful-card__swatch-more-label--desktop': {
              display: {'base': 'inline', 'lg': 'inline'},
            },
            '& .contentful-card__swatch-more-label': {
              fontSize: {base: '12px', lg: '12px'},
            },
          },
        },
      },
      '& .component--category-card-grid + .component--section-panel .section-panel-split--5050:has(.contentful-card__content)': {
        paddingTop: {base: '16px', lg: '80px'},
      },
      '& .component-container__background:has(.contentful-accordion-panel)': {
        marginTop: {base: 'unset', lg: '40px'},
      },
      '& .contentful-accordion-panel': {
        maxWidth: '1440px',
        paddingX: {base: '20px', lg: '80px'},
        paddingY: {base: '60px', lg: '80px'},
        marginX: 'auto',
        '& h2, & .chakra-button, & .chakra-text': {
          color: '#000',
        },
        '& svg': {
          color: '#8C683B',
        },
        '& ul': {
          listStyleType: 'disc',
          listStylePosition: 'outside',
          paddingLeft: {base: 2, lg: 5},
          marginTop: 2,
          marginBottom: 4,
          paddingLeft: 5,
          marginLeft: '2px',
        },
        '& ol': {
          listStyleType: 'decimal',
          listStylePosition: 'outside',
          paddingLeft: {base: 2, lg: 5},
          marginTop: 2,
          marginBottom: 4,
          paddingLeft: 5,
          marginLeft: '2px',
        },
        '& .contentful-accordion': {
          '& .contentful-accordion__item': {
            borderBottom: 'unset',
            '& .contentful-accordion__button': {
              paddingY: {base: '24px', lg: '24px'},
              color: '#000',
            },
            '& .contentful-accordion__panel': {
              color: '#000',
              fontFamily: 'body',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 1.6,
              paddingBottom: {base: '24px', lg: '24px'},
              paddingRight: {base: '24px', lg: '24px'},
              paddingTop: 0,
              '& .rich-text-content, & .amb-markup, & p, & li, & .chakra-text': {
                color: '#000',
                fontFamily: 'body',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 1.6,
              },
              '& a, & .chakra-link': {
                color: '#000',
              },
            },
          },
        },
        '& .contentful-accordion-panel__title, & .contentful-accordion__title': {
          fontWeight: 500,
        },
      },
      '& .component--category-card-grid': {
        paddingX: {base: '4px', lg: '80px'},
      },
      '& .contentful-card__swatch-more-label': {
        fontSize: {base: '12px', lg: '12px'},
      },
    },
  }
};
